'use client';

import { useRouter } from 'next/navigation';
import { Copyright } from 'lucide-react';
import IconAdaptive from '@/components/IconAdaptive';
import ImageAdaptive from '@/components/ImageAdaptive';

export default function MobileHeader() {
    const router = useRouter();
    return (
        <div
            className="sticky top-0 w-full bg-color-white-base shadow-lg z-30 flex flex-col justify-end min-h-[45px]"
            style={{ paddingTop: 'env(safe-area-inset-top)' }}
        >
            <div className="flex items-center justify-center h-[45px]">
                <div className="flex items-center gap-1 cursor-pointer" onClick={() => router.push('/')}>
                    <span className="font-nova font-black text-color-base text-2xl">fox.</span>
                    <div className="font-montserrat font-black text-color-base pt-2">
                        <IconAdaptive
                            Icon={Copyright}
                            strokeWidth={2.25}
                            baseSize={12}
                            className="text-color-base mr-[-3px]"
                        />
                    </div>
                    <div className="pt-2">
                        <ImageAdaptive src="/images/logo/schoomy.svg" baseWidth={82} />
                    </div>
                </div>
            </div>
        </div>
    );
}
